const inputs = {
  name: {
    id: 'name',
    name: 'name',
    input: 'textField',
    label: 'macro.form.name.label',
    placeholder: 'companyList.form.name.placeholder',
    rules: {
      required: { value: true },
    },
  },
  description: {
    id: 'description',
    name: 'description',
    input: 'textField',
    label: 'macro.form.description.label',
  },
  inventory: {
    id: 'inventory_id',
    name: 'inventory',
    input: 'select',
    label: 'macro.form.inventory.label',
    helperText: 'macro.form.inventory.helperText',
    rules: {
      required: { value: true },
    },
  },
  type: {
    id: 'typeId',
    name: 'type',
    input: 'select',
    label: 'macro.form.type.label',
    rules: {
      required: { value: true },
    },
  },
  hosts: {
    id: 'hosts',
    name: 'hosts',
    input: 'textField',
    label:       'macro.form.hosts.label',
    placeholder: 'macro.form.hosts.placeholder',
    helperText:  'macro.form.hosts.helperText',
  },
  credential: {
    id: 'credentials_id',
    name: 'credential',
    input: 'select',
    label: 'macro.form.credential.label',
    helperText: 'macro.form.credential.helperText',
    rules: {
      required: { value: true },
    },
  },
  configFile: {
    id: 'configFile',
    name: 'configFile',
    label: 'macro.form.configFile.label',
    helperText: 'macro.form.configFile.helperText',
  },
  configFileSelect: {
    id: 'configFileSelect',
    name: 'configFileSelect',
    input: 'select',
    label: 'macro.form.configFile.label',
    helperText: 'macro.form.configFile.helperText',
  },
}

export default inputs;